@import 'core';

$ads-card-image-align-horizontal: center;
$ads-card-image-align-vertical: center;
$ads-card-image-background-position: 50% 50%;
$ads-card-image-background-repeat: no-repeat;
$ads-card-image-background-size: cover;
$ads-card-image-padding: 16px;
$ads-card-background-image-height: 100%;
$ads-card-background-overlay-image-height: inherit;


/**
 * @prop --ads-card-image-align-horizontal: Horizontal alignment of the card image
 * @prop --ads-card-image-align-vertical: Vertical alignment of the card image
 * @prop --ads-card-image-background-position: Background position of the card image
 * @prop --ads-card-image-background-repeat: Background repeat of the card image
 * @prop --ads-card-image-background-size: Background size of the card image
 * @prop --ads-card-image-padding: Padding of the card image
 * @prop --ads-card-background-image-height: Height of the background image
 * @prop --ads-card-background-overlay-image-height: Height of the background overlay image
 */

:host {
  align-items: var(--ads-card-image-align-horizontal, $ads-card-image-align-horizontal);
  justify-content: var(--ads-card-image-align-vertical, $ads-card-image-align-vertical);

  display: flex;
  flex: 1 0 auto;
  height: 100%;
  position: relative;
  width: 100%;

  *,
  *::before,
  *::after {
    box-sizing: border-box;
  }
}

:host(.has-background) {
  width: 100%;
}

.c-card-image {
  background-color: var(--ads-card-image-background-color, $ads-card-image-background-color);
  background-position: var(--ads-card-image-background-position, $ads-card-image-background-position);
  background-repeat: var(--ads-card-image-background-repeat, $ads-card-image-background-repeat);
  min-height: var(--ads-card-image-min-height, $ads-card-image-min-height);

  &__wrapper {
    align-items: center;
    background-position: inherit;
    background-repeat: inherit;
    bottom: 0;
    display: flex;
    flex: 1 0 auto;
    height: 100%;
    justify-content: center;
    left: 0;
    min-height: var(--ads-card-image-min-height, $ads-card-image-min-height);
    position: relative;
    right: 0;
    top: 0;
    width: 100%;
  }

  &__background {
    background-position: inherit;
    background-repeat: inherit;
    background-size: var(--ads-card-image-background-size, $ads-card-image-background-size);
    display: block;
    height: var(--ads-card-background-image-height, $ads-card-background-image-height);
    min-height: inherit;
    width: 100%;

    &.ken-burns {
      transition: transform .35s;
      transform: scale(1.25);

      &:focus, &:hover {
        transition: transform .2s;
        transform: scale(1.35);
      }
    }
  }

  &__overlay-image {
    background-repeat: inherit;
    display: block;
    height: var(--ads-card-background-overlay-image-height, $ads-card-background-overlay-image-height);
    left: 0;
    min-height: 180px;
    min-width: 180px;
    padding-bottom: 10px;
    padding-top: 10px;
    position: absolute;
    top: 0;

    &.ken-burns {
      transform: scale(1.25);
      transition: transform .35s;

      &:focus, &:hover {
        transform: scale(1.35);
        transition: transform .2s;
      }
    }
  }

  &__image {
    display: block;
    max-width: 100%;
    padding: var(--ads-card-image-padding, $ads-card-image-padding);
    text-align: center;

    img {
      max-width: inherit;
    }
  }
}
